<template>
  <website-layout>
    <home-header/>
    <v-layout class="my-3">
      <div class="container">
        <h1 class="my-5">Impressum</h1>

        <h2 class="my-5">Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
        <p class="my-3">Elvira Hausmann Gastronomiebetriebe GmbH <br >
          Kreuzhof 4<br >
          66872 Ramstein-Miesenbach</p>

        <p class="my-3">Handelsregister: HRB 31450<br >
          Registergericht: Zweibrücken</p>

        <p class="my-3">Umsatzsteuer-ID: DE303793872</p>

        <h2 class="my-5">Kontakt</h2>
        <p class="my-3">E-Mail: kontakt@elsazeit.de</p>

        <h2 class="my-5">Streitschlichtung</h2>
        <p class="my-3">Die Europ&auml;ische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener">https://ec.europa.eu/consumers/odr</a>.<br > Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>

        <p class="my-3">Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

        <h3 class="my-3">Haftung f&uuml;r Inhalte</h3>
        <p class="my-3">Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit hinweisen.</p>
        <p class="my-3">Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
        <h3 class="my-3">Haftung f&uuml;r Links</h3>
        <p class="my-3">Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
        <p class="my-3">Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
        <h3 class="my-3">Urheberrecht</h3> <p class="my-3">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.</p>
        <p class="my-3">Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>

        <p class="my-3">Quelle: <a href="https://www.e-recht24.de">eRecht24</a></p>

      </div>
    </v-layout>
    <home-footer/>
  </website-layout>
</template>

<script>

import HomeHeader from '@/components/routes/home/HomeHeader'
import HomeFooter from '@/components/routes/home/HomeFooter'
export default {
  name: 'Imprint',
  components: { HomeFooter, HomeHeader }
}
</script>

<style scoped>

</style>
